export default __webpack_public_path__ + "static/media/store_svg11.692e1515.svg";